<script setup lang="ts">
import useModal, { ModalTypes, modals } from '../../composables/useModal';
import Modal from '../Modal.vue';
import { useLocale } from '../../composables/useLocale';

const { t } = useLocale();

type Props = {
  name: ModalTypes;
  schoolUid: string;
};
const props = defineProps<Props>();

const { isOpen, close } = useModal(props.name);
const { open: openCreateSingleUserModal } = useModal(modals.CREATE_SINGLE_USER);
const { open: openCreateMultipleUsersModal } = useModal(modals.CREATE_MULTIPLE_USERS);

const openSingleUserModal = () => {
  close();
  openCreateSingleUserModal();
};

const openMultipleUsersModal = () => {
  close();
  openCreateMultipleUsersModal();
};
</script>

<template>
  <Modal
    :name="name"
    :title="t('lcp.new_user')"
    :is-open="isOpen"
    :show-cancel-action="false"
    :action-label="t('lcp.multiple_users')"
    action-prepend-icon="mdi-account-multiple-plus"
    :action="openMultipleUsersModal"
    :secondary-action-label="t('lcp.single_user')"
    :secondary-action="openSingleUserModal"
    secondary-action-color="primary"
    secondary-action-variant="flat"
    secondary-action-prepend-icon="mdi-account-plus"
    :center-actions="true"
  >
    <p>{{ t('lcp.create_user_description') }}</p>
  </Modal>
</template>
